{
	"CityObjects": {
		"id-2": {
			"geometry": [
				{
					"boundaries": [
					[
					  [ [8, 9, 10, 11] ],
					  [ [12, 13, 9, 8] ],
					  [ [13, 14, 10, 9] ],
					  [ [14, 15, 11, 10] ],
					  [ [15, 12, 8, 11] ],
					  [ [15, 14, 13, 12] ]
					]
					],
					"lod": "2",
					"type": "Solid"
				}
			],
			"attributes": {
			"function": "something"
			},
			"type": "GenericCityObject"
		},
		"id-1": {
			"geometry": [
				{
					"boundaries": [
						[
							[
								[
									0,
									1,
									2,
									3
								]
							],
							[
								[
									4,
									5,
									1,
									0
								]
							],
							[
								[
									5,
									6,
									2,
									1
								]
							],
							[
								[
									6,
									7,
									3,
									2
								]
							],
							[
								[
									7,
									4,
									0,
									3
								]
							],
							[
								[
									7,
									6,
									5,
									4
								]
							]
						]
					],
					"lod": "1",
					"type": "Solid"
				}
			],
			"attributes": {
				"function": "something"
			},
			"type": "GenericCityObject"
		},


	},
	"type": "CityJSON",
	"version": "2.0",
	"versioning": {
		"versions": {
			"v1": {
			  "objects": {
				"id-1_v1": "id-1",
				"id-2_v1": "id-2"
			  }
			},
			"v2": {
			  "objects": {
				"id-2_v2": "id-2"
			  }
			},
			"v3": {
			  "objects": {
				"id-1_v3": "id-1"
			  }
			}
	  }
	},
	"vertices": [
		[
			0,
			0,
			1000
		],
		[
			1000,
			0,
			1000
		],
		[
			1000,
			1000,
			1000
		],
		[
			0,
			1000,
			1000
		],
		[
			0,
			0,
			0
		],
		[
			1000,
			0,
			0
		],
		[
			1000,
			1000,
			0
		],
		[
			0,
			1000,
			0
		],
    [2000, 0, 1000],
    [3000, 0, 1000],
    [3000, 1000, 1000],
    [2000, 1000, 1000],
    [2000, 0, 0],
    [3000, 0, 0],
    [3000, 1000, 0],
    [2000, 1000, 0]
	],
	"metadata": {
		"geographicalExtent": [
			0.0,
			0.0,
			0.0,
			1.0,
			1.0,
			1.0
		]
	},
	"transform": {
		"scale": [
			0.001,
			0.001,
			0.001
		],
		"translate": [
			0.0,
			0.0,
			0.0
		]
	},
	"extensions": {}
}